import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, of, tap } from 'rxjs';

import { Race } from '../interfaces/race';
import { StarSystem } from '../interfaces/star-system';
import { Campaign } from '../interfaces/campaign';
import { InformationStarSystem } from '../interfaces/information-star-system';

@Injectable({
  providedIn: 'root'
})
export class StarSystemService {
  race: Race[] = [];
  starSystem: StarSystem[] = [];

  constructor (private http: HttpClient) { }

  processStarSystem(starSystem: StarSystem) {
    localStorage.setItem(starSystem._id, JSON.stringify(starSystem));
  };

  processStarSystems(starSystems: StarSystem[], campaignId: string) {
    localStorage.setItem('starSystemsFor' + campaignId, JSON.stringify(starSystems));
    for (const starSystem of starSystems) {
      localStorage.setItem(starSystem._id, JSON.stringify(starSystem));
    }
  };

  loadFullStarSystems(campaignId: string): Observable<StarSystem[]> {
    if (campaignId == null) {
      throw new Error("No Active Campaign");
    }
    return this.http.get<StarSystem[]>('/api/starSystem/full/' + campaignId);
  };

  getAllStarSystemsForCampaign(campaignId: string): Observable<StarSystem[]> {
    if (campaignId == null) {
      throw new Error("campaignId can not be undefined");
    }
    // let fullStarSystemsJson = localStorage.getItem('starSystemsFor' + campaignId);
    // if (fullStarSystemsJson) {
    //   console.log('getAllStarSystemsForCampaign has cache');
    //   return of<StarSystem[]>(JSON.parse(fullStarSystemsJson) as StarSystem[]);
    // }
    return this.loadFullStarSystems(campaignId);
  };

  getStarSystem(starSystemId: string): Observable<StarSystem> {
    if (!starSystemId || starSystemId == '') {
      return of(undefined);
    }

    let starSystemData = localStorage.getItem(starSystemId);
    if (starSystemData) {
      let starSystem: StarSystem = JSON.parse(starSystemData);
      delete starSystem.warpPoints;
      return of<StarSystem>(starSystem);
    }

    return this.http.get<StarSystem>('/api/starSystem/id/' + starSystemId).pipe(
      tap(starSystem => this.processStarSystem(starSystem))
    );
  };

  getStarSystemsForRaceId(raceId: string): Observable<StarSystem[]> {
    return this.http.get<StarSystem[]>('/api/starSystem/race/' + raceId);
  };

  getStarSystemsWithFleetsForRace(raceId: string): Observable<StarSystem[]> {
    return this.http.get<StarSystem[]>('/api/starSystem/fleet/race/' + raceId);
  };

  // getShortStarSystemsForCampaign (campaignId: string): Observable<StarSystem[]> {
  //   if (campaignId == null) {
  //     throw new Error("campaignId can not be undefined");
  //   }
  //   // let fullStarSystemsJson = localStorage.getItem('starSystemsFor' + campaignId);
  //   // if (fullStarSystemsJson) {
  //   //   console.log('getAllStarSystemsForCampaign has cache');
  //   //   return of<StarSystem[]>(JSON.parse(fullStarSystemsJson) as StarSystem[]);
  //   // }
  //   return this.http.get<StarSystem[]>('/api/starSystem/all/' + campaignId);
  // };

  newStarSystem(campaign: Campaign, race: Race = undefined, starSystemNumber: number = undefined, overrides: { [key: string]: any; } = {}): Observable<StarSystem> {
    return this.http.post<StarSystem>('/api/starSystem', {
      campaign: campaign,
      race: race,
      starSystemNumber: starSystemNumber,
      overrides: overrides
    });
  };

  getStarSystemAdmin(starSystemId: string): Observable<StarSystem> {
    return this.http.get<StarSystem>('/api/starSystem/withWarpPoints/id/' + starSystemId);
  };
}

// Old AngularJS
// getStarSystemAdmin = function (starSystemId) {
//     let starSystemData = localStorage.getItem(starSystemId);
//     if (starSystemData) {
//         let starSystem = JSON.parse(starSystemData);
//         if (starSystem.warpPoints) {
//             return Promise.resolve(starSystem);
//         }
//     }

//     return $http.get('/api/starSystem/withWarpPoints/id/' + starSystemId).then(
//         function (response) {
//             let starSystem = response.data;
//             localStorage.setItem(starSystem._id, JSON.stringify(starSystem));
//             return starSystem;
//         }
//     );
// };
